<template>
  <div id="content" class="dict_manager">
    <ProjectNameModal :dialogVisible='dialogName' @close="dialogName=false" @newValueIsProposed="setewValueName($event)" formName="Edit your value name" :projectName="selectedValue.name" ></ProjectNameModal>

    <div class="container content_div">
      <div class="col-12 text-center">
        <select v-model="dict_selected" placeholder="Select">
          <option value="" disabled selected>Select</option>
          <option v-for="(option, $i) in dicts" :value="option" :key="$i">
            {{$filters.beautyDict(option) }}
          </option>
        </select>
  <button class="next_step_btn text-center mt-3" @click="loadDictDatas()" type="button" :disabled="!dict_selected" name="button">Load taxonomy</button>
      </div>
      <div class="col-12 mt-5" v-if="dict_loaded">

        <div class="col-12 action_zone">
          <span class="actionZoneTitle">CHOOSE YOUR ACTION </span>
         <!-- <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link> -->
         <div class="goRight">

           <div class="zoneBtn" >
             <button @click="openModal()" class="action_btn" type="button" name="button">Add value</button>
           </div>
           <div class="zoneBtn" v-if='selectedItems.length > 0'>
             <button class="action_btn" type="button" @click="massRemove()" name="button">Remove selection</button>
           </div>
           <div class="zoneBtn" v-if='selectedItems.length > 1'>
             <button class="action_btn" type="button" @click="massMerged()" name="button">Merge selection</button>
           </div>


           </div>
       </div>
          <div class="table-responsive ">

          <table class="table table-stripped">
            <thead class="thead-dark">
              <tr>
                <th></th>
                <th class="text-center">Ordre  <v-btn variant="outlined" size="x-small" icon="mdi-sort" @click="sortBy('ordre')"></v-btn></th>
                <th>Displayed as <v-btn variant="outlined" size="x-small" icon="mdi-sort" @click="sortBy('name')"></v-btn></th>
                <th>DB Value</th>
                <th>Restricted to particular customer</th>
                <th>#</th>
              </tr>
            </thead>
            <tr v-for="(data, $d) in sortedItems" :key="$d" style="padding:10px;">
              <td><input type="checkbox" v-model="selectedItems" :value="data._id.$oid"></td>
              <td class="text-center">{{data.ordre}}</td>
              <td>{{data.name }} <v-btn variant="outlined" size="x-small" icon="mdi-pencil" @click="rename(data)"></v-btn></td>
              <td>{{data.value}}</td>
              <td>{{data.customer ? 'Yes' : 'No'}}
            </td>
              <td>
                  <!-- <button class="btn btn-remove" style="margin:10px;"  @click="removeItem(data._id.$oid)">X <span class="hidden-sm">Remove</span></button> -->
                  <button class="btn btn-info" style="margin:10px;"  @click="enableForAll(data._id.$oid)" v-if="data.customer">Make available for all</button>
              </td>
            </tr>
          </table>
                </div>

              <div class="text-center">
                <NewValueModal :dialogVisible='dialog' @close="dialog=false" @newValueIsProposed="setNewValueCAS($event)" :formName="'Add item to dict '+ $filters.beautyDict(dict_selected) " ></NewValueModal>
              </div>
      </div>


    </div>


  </div>


</template>
<script>
import ProjectNameModal from '@/components/modals/projectNameModal.vue'

import NewValueModal from '@/components/modals/addValueAdmin.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
import api from '../../tools/api';
export default {
  components: {
NewValueModal,
ProjectNameModal
    // BookACall
  },
  data() {
    return {
      dialog : false,
      dialogName : false,
      selectedValue: {name:""},
      dialogAssets: false,
      addMoreInfo : false,
      add_other_location: "",
      currentSearchFieldForComment : "",
      dicts: [],
      dict_selected: "",
      dict_loaded: false,
      dict_datas: [],
      selectedItems: [],
      sortKey : 'ordre',
    }
  },
  methods:{
    rename(data){
        this.selectedValue = data;
        this.dialogName = true;
    },
    setewValueName(v){
      if(v){
        console.log(this.selectedValue);
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict_rename_many/"+this.dict_selected,
        {
          mongoid : this.selectedValue._id.$oid,
          newname : v,
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Renamed in the database");
         this.loadDictDatas();
         this.selectedValue = {name:""};
         this.dialogName =false;

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    massRemove(){
      console.log(this.selectedItems);
      if (window.confirm("Do you confirm the deletion of these entries?")) {
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict_delete_many/"+this.dict_selected,
        {
          delete_ids : this.selectedItems
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Removed from the database");
         this.loadDictDatas();
         this.selectedItems = [];

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    massMerged(){
      if (window.confirm("Do you confirm the merge of these entries?")) {
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict_fusion_many/"+this.dict_selected,
        {
          delete_ids : this.selectedItems
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Merged in the database");
         this.loadDictDatas();
         this.selectedItems = [];

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    openModal(){
      this.dialog = true;
    },
    closeModal(){
      this.currentSearchFieldForComment = "";
      this.dialog = false;
    },

    setNewValueCAS(v){
      if(v){
        console.log(v);
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict",{
          value: v.customerValue,
          ordre : v.ordre,
          dict: this.dict_selected
        },{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          this.dict_datas.push(r.data);
          toast.success("Added to the database");
        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
      this.dialog = false;
    },
    loadDictDatas(){
      console.log(this.dict_selected);
      this.dict_datas = [];
      this.dict_loaded = false;
      api.get(process.env.VUE_APP_API_URL+"/restrict/dict/"+this.dict_selected,{
        headers: {
            'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r.data);
        this.dict_datas = r.data;
        this.selectedItems = [];

        this.dict_loaded = true;
      }).catch( error => {
        if(error.response.data.message) toast.error(error.response.data.message);
        else toast.error("Sorry, an error occurs. Please try again !");
      })
    },
    removeItem(id){
      console.log(id);
      if (window.confirm("Do you confirm the deletion of this entry?")) {
        api.delete(process.env.VUE_APP_API_URL+"/restrict/dict/"+this.dict_selected+"/"+id,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("Removed from the database");
          // this.loadDictDatas();
          this.dict_datas = this.dict_datas.filter(e => e._id.$oid != id);
        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    enableForAll(id){
      console.log(id);
      if (window.confirm("Please confirm that you want to set this entry as enable for all customers ")) {
        api.post(process.env.VUE_APP_API_URL+"/restrict/dict/enableForAll/"+this.dict_selected+"/"+id,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("Made available for all customers.");
           this.loadDictDatas();
        //  this.dict_datas = this.dict_datas.filter(e => e._id.$oid != id);
        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }
    },
    sortBy(key) {
      console.log("sortby",this.sortKey);
  // Set the sortKey to the specified key
      this.sortKey = key;
    },
    sortItems() {
      console.log("run",this.sortKey);
      // Return a sorted copy of the items array based on the current sortKey
      return [...this.dict_datas].sort((a, b) => {
          const aValue = String(a[this.sortKey]);
          const bValue = String(b[this.sortKey]);
          return aValue.localeCompare(bValue);
        }

      );
    }
  },
  computed: {
    sortedItems() {
      return [...this.dict_datas].sort((a, b) => {
          const aValue = String(a[this.sortKey]);
          const bValue = String(b[this.sortKey]);
          return aValue.localeCompare(bValue);
        }

      );
    }
  },
  mounted(){
     // this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/dict",{
       headers: {
           'Content-Type': 'application/json',
       }
     }).then( (r) => {
       console.log(r.data);
       this.dicts = r.data;

     }).catch( error => {
       if(error.response.data.message) toast.error(error.response.data.message);
       else toast.error("Sorry, an error occurs. Please try again !");
     })
  },

}
</script>
<style media="screen">
.dict_manager{
  padding-top:50px;
  padding-bottom: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}



.dict_manager  input,
.dict_manager  select{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}

.btn-remove,
  .btn-remove:hover{
  margin-top:10px;
  margin-bottom:10px;
  color: #FFF !important;
  border: 1px solid #b90707;
  background: #b90707 !important;
}

@media screen and (max-width: 990px){
  .hidden-sm{
    display:none;
  }
}


.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 50px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 50px;
}
.disabledRlink{
  pointer-events: none;
  opacity: 0.7;
}

.zoneBtn{
  position:relative;
  display: flex;

}

.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
</style>
